import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { db, doc, getDoc } from "../../firebase/Firebase"; // Ensure you're importing Firestore methods
import { useAuthState } from "react-firebase-hooks/auth";
import "./balance.css";

const Balance = () => {
  // Get the current logged-in user from Firebase Authentication
  const [user, loading, error] = useAuthState(getAuth());

  const [userData, setUserData] = useState(null); // To store user data including balance
  const [message, setMessage] = useState(""); // For displaying any messages like errors

  // Fetch user data (balance) when the user logs in
  useEffect(() => {
    if (user) {
      const fetchUserData = async () => {
        try {
          const userRef = doc(db, "users", user.uid); // Use the user ID from Firebase Auth
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            setUserData(userSnap.data());
          } else {
            setMessage("User not found!");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          setMessage("Error loading user data.");
        }
      };

      fetchUserData();
    }
  }, [user]); // This will run whenever the user object changes

  if (loading) {
    return <div>Loading...</div>; // Display loading while the user data is being fetched
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!userData) {
    return <div>No data available</div>; // If no data is available for the user
  }

  return (
    <div className="balancePage">
      <h2>Welcome {user.displayName ? user.displayName : "Guest"}</h2>
      {message && <p>{message}</p>}

      <div>
        <p>Email Address: {user.email}</p>{" "}
        {/* Display the email from Firebase Auth */}
        <p>Balance: ${userData.balance ? userData.balance : "0.00"}</p>
      </div>
    </div>
  );
};

export default Balance;
